import { routes } from '../api/routes';
import { browserHistory } from 'react-router';

const {
	orderAPIUrl,
	nodeAPIurl,
	orders,
	reportsAPIUrl,
	priceTags,
	brochure,
	productAPIUrl,
	product,
	servicesAPIUrl,
	customerAPIUrl,
	loginAPIUrl,
	loginAPIKey,
	westLoginAPIKey,
	exports,
	users,
	userAPIUrl,
	prelogin,
	homepage,
	resources,
	list,
	cart,
	bootAPIUrl,
	pNetAPIUrl,
	showDebuggerConsoles,
	tca,
	ajdprcmod,
} = routes;

import _ from 'lodash';

/*
	This method will be used for making all service call whether its get, post, hybrid
*/
import {
	sendRequest,
	fetchProductNumberKeywordResult
} from '../api/sendRequest';

/*
	common utility function
*/
import {
	processPricingResponse,
	processPimDataResponse
} from '../util';
import { PNET_APP_QUERY_PARAM } from '../../components/common/partsNetConstants';

/***************************************************************
	ALL ACTIONS DISPATCH TO MAKE SERVICE CALL GOES BELOW
***************************************************************/
/*
	url: service url,
	path: path of service call,
	apiKey: apiKey if any, else it will be blank,
	method: method,
	payload: required payload for service call it can be object or string based on type of method,
	hybridQueryParams: hybrid query params,
	loadingFunction: specific loading function,
	reducerAction: in case of data needs to be save in to store then this will be passed else null will be passed,
	callback: in case of any call back function after getting data from service response
	redirectToError: this is by default true, in case if error redirection needs to ignore then pass false
*/
export function generalActionToMakeServiceCall(url, path, apiKey, method, payload, hybridQueryParams, showLoader, reducerAction, callback, redirectToError = true) {
	return (dispatch) => {
		showLoader && dispatch(ajaxRequestInitiated());
		sendRequest(url, path, apiKey, method, payload, hybridQueryParams).then(response => {
			if(path === 'pim' && method === 'POST') {
				response = processPimDataResponse(response);
			}
			// This will be only passed in case of data needs to be updated into reducer store
			reducerAction && dispatch(reducerAction(response));
			// If showLoader is true then only it will dispatch below action, it will increase count of pending ajax requset by 1
			showLoader && dispatch(ajaxRequestCompleted());
			// Default redirectToError is true until and unless if we have to ignore it
			if(response.responseMessage=="Exception in getting address list"){
				response.status=true;
				redirectToError=false;
			}
			if(redirectToError && !response.status) {
				dispatch(addErrorDetailsToStore({
					page: window.location.pathname,
					serviceURL: url + path,
					hybridQueryParams,
					payload,
					status: response.status
				}));
				// Redirect to error page if error occured
				browserHistory.push('/error');
			} else {
				// pass data to call back function if any call back function is there
				callback && callback(response);
			}
		}).catch(err => {
			// In case session expired
			showDebuggerConsoles && console.log("##### actions -> catch : ", err);
			if(err.status === 401) {
				dispatch(updateSessionStatus(true));
			} else {
				if(redirectToError) {
					// dispatch(addErrorDetailsToStore({
					// 	page: window.location.pathname,
					// 	serviceURL: url + path,
					// 	hybridQueryParams,
					// 	payload,
					// 	message: err && err.message ? err.message : '',
					// 	status: err.status
					// }));
					browserHistory.push('/error');
			 	}
				// pass error data to call back function if any call back function is there
				callback && callback({
					status: false,
					responseMessage: err.message
				});
			}
			// If showLoader is true then only it will dispatch below action, it will decrease count of pending ajax requset by 1
			showLoader && dispatch(ajaxRequestCompleted());
		})
	}
}
export function personShipTo(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.personShipTo.path,
		'',
		orders.personShipTo.method,
		payload,
		'',
		true,
		null,
		callback
	);
}
export function cancelPackageOrder(payload, queryString, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.cancelPackageOrder.path,
		'',
		orders.cancelPackageOrder.method,
		payload,
		queryString,
		true,
		null,
		callback
	);
}
export function decliningBalance(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.decliningBalance.path,
		'',
		orders.decliningBalance.method,
		payload,
		'',
		true,
		null,
		callback,
		false
	);
}
// validate warehouse Code
export function validateWarehouseCode(queryString, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.validateWarehouseCode.path,
		'',
		orders.validateWarehouseCode.method,
		queryString,
		'',
		true,
		null,
		callback
	);
}
// Get billing References
export function getBillingReferences(queryString, callback, errorRedirection = true) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.billingReferences.path,
		'',
		orders.billingReferences.method,
		queryString,
		'',
		true,
		null,
		callback,
		errorRedirection
	);
}

// Get token account
export function getTokenAccount(queryString, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		queryString,
		'',
		true,
		null,
		callback
	);
}

// getting cybersource page
export function getCyberSource(queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.signature.path,
		'',
		orders.signature.method,
		queryStringParams,
		'',
		true,
		null,
		callback
	);
}

// getting org attributes
export function getOrgAttributes(queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		queryStringParams,
		'',
		true,
		saveOrgAttributes,
		callback
	);
}

// create order service call
export function createNewOrder(payload, hybridQueryParams, useBootApi, callback) {
	return generalActionToMakeServiceCall(
		useBootApi ? bootAPIUrl : orderAPIUrl,
		orders.getServices.path,
		'',
		orders.getServices.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// create order service call
export function deleteReturn(payload, callback) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.deleteReturn.path,
		'',
		orders.deleteReturn.method,
		null,
		payload,
		true,
		null,
		callback
	);
}

// Get restocking fee
export function getRestockingFee(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.restockingFee.path,
		'',
		orders.restockingFee.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// update booked order service call
export function updateBookedOrder(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getServices.path,
		'',
		orders.getServices.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback,
		false
	);
}

// Get orderable services
export function getOrderableServices(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.getServices.path,
		'',
		orders.getServices.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// Get packages list
export function getPackageList(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getOrderListBoot.path,
		'',
		orders.getOrderListBoot.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Get order detail list for packages
export function getOrderDetailsList(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getOrderListBoot.path,
		'',
		orders.getOrderListBoot.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Get orders list
export function getOrderList(payload, callback, errorRedirection = true) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getOrderListBoot.path,
		'',
		orders.getOrderListBoot.method,
		payload,
		'',
		true,
		null,
		callback,
		errorRedirection
	);
}

// Get all files
export function getFiles(payload, callback) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.getFiles.path,
		'',
		orders.getFiles.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// approve return request
export function approveReturn(payload, queryString, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.approveReturn.path,
		'',
		orders.approveReturn.method,
		payload,
		queryString,
		true,
		null,
		callback
	);
}

// get GE Ad Builder encrypted data
export function getGEAdBuilderKey(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		resources.mapGuideLines.path,
		'',
		resources.mapGuideLines.method,
		payload,
		'',
		true,
		saveGEAdBuilderKey,
		callback
	);
}

// get sales handbook Agreement data
export function getSalesAgreementHandBook(queryString, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		resources.handbooks.path,
		'',
		resources.handbooks.method,
		queryString,
		'',
		true,
		saveSalesAgreementHandBookData,
		callback
	);
}

// Get backorders list
export function checkForBackOrders(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getOrderListBoot.path,
		'',
		orders.getOrderListBoot.method,
		payload,
		'',
		showLoader?true:false,
		saveBackOrders,
		callback,
		false
	);
}

// Get bulk order hold list
export function checkForBulkOrdersHold(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getOrderListBoot.path,
		'',
		orders.getOrderListBoot.method,
		payload,
		'',
		showLoader?true:false,
		saveBulkOrdersHold,
		callback,
		false
	);
}

// Get order details
export function getOrderDetails(payload, callback, saveToStore = true, isPart = false) {
	return generalActionToMakeServiceCall(
		isPart ? pNetAPIUrl : bootAPIUrl,
		orders.getOrderListBoot.path,
		'',
		orders.getOrderListBoot.method,
		payload,
		'',
		true,
		saveToStore ? saveOrderDetails : null,
		callback
	);
}

// change request access
export function updateUserAccounts(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.access.path,
		'',
		users.access.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// get LDAP email address for other user
export function getUserLDAPEmail(queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.adminDetails.path,
		'',
		users.adminDetails.method,
		queryStringParams,
		null,
		true,
		null,
		callback
	);
}

export function logout() {
	localStorage.removeItem("RDDate");
	localStorage.removeItem("zipCodeChanged");
	//Clearing stores as well with initial state
	resetErrorsObjectInStore();
	resetBrochureObjectInStore();
	resetExportObjectInStore();
	resetHomePageObjectInStore();
	resetLoadingObjectInStore();
	resetOrderObjectInStore();
	resetPackageObjectInStore();
	resetPriceTagsObjectInStore();
	resetProductObjectInStore();
	resetRegistrationObjectInStore();
	resetResourcesObjectInStore();
	resetSearchKeywordObjectInStore();
	resetUserObjectInStore();
	resetCartObjectInStore();
	resetListObjectInStore();
	sessionStorage.clear();
	localStorage.clear();
	window.location.href = routes.logoutSSOUrl;
}

// admin DL Check
export function adminDLCheck(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.adminDetails.path,
		'',
		users.adminDetails.method,
		payload,
		null,
		true,
		updateUserIsInDLOrNot,
		callback
	);
}

// check Manage Site Access Check
export function checkManageSiteAccess(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.adminDetails.path,
		'',
		users.adminDetails.method,
		payload,
		null,
		true,
		saveManageSiteAccess,
		callback
	);
}

// change notification preferences
export function updateUserNotifications(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.notifications.path,
		'',
		users.notifications.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// change notification preferences
export function updateAccountResponsibility(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.accountResponsibility.path,
		'',
		users.accountResponsibility.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// change velocity customer
export function getAccountResponsibility(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		saveAccountResponsibility,
		callback
	);
}

// Get tax
export function getTax(payload, hybridQueryParams, callback, isPart = false) {
	return generalActionToMakeServiceCall(
		isPart ? pNetAPIUrl : orderAPIUrl,
		orders.getTax.path,
		'',
		orders.getTax.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// Export orders to excel
export function exportOrdersDetails(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.exportOrders.path,
		'',
		orders.exportOrders.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

export function exportManageOrdersDetails(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.exportManageOrders.path,
		'',
		orders.exportManageOrders.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// Cancel order
export function cancelOrderDetails(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.cancelOrder.path,
		'',
		orders.cancelOrder.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// Delete order
export function deleteOrderDetails(payload, hybridQueryParams, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.deleteOrder.path,
		'',
		orders.deleteOrder.method,
		payload,
		hybridQueryParams,
		showLoader,
		null,
		callback
	);
}

// Get shipping addresses
export function getShippingAddresses(payload, showLoader, callback, saveToStore = false) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getShippingAddresses.path,
		'',
		orders.getShippingAddresses.method,
		payload,
		'',
		showLoader?true:false,
		saveToStore?saveZipCodeDetail:null,
		callback
	);
}

// Get shipping method
export function getShippingMethod(payload, callback) {
	return generalActionToMakeServiceCall(
		nodeAPIurl,
		orders.getShippingMethod.path,
		'',
		orders.getShippingMethod.method,
		payload,
		'',
		true,
		saveShippingMethod,
		callback
	);
}

// Get Delivery Calendar
export function getDeliveryCalendar(payload, hybridQueryParams, showLoader, callback) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.getDeliveryCalendar.path,
		'',
		orders.getDeliveryCalendar.method,
		payload,
		hybridQueryParams,
		showLoader,
		null,
		callback
	);
}

// Get minimum delivery
export function getMinimumDelivery(queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.account.path,
		'',
		users.account.method,
		queryStringParams,
		'',
		true,
		null,
		callback
	);
}

// change phone number
export function changePhoneNumber(queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.update.path,
		'',
		users.update.method,
		{},
		queryStringParams,
		true,
		null,
		callback
	);
}

// get report count
export function getReportCount(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		resources.reportCount.path,
		'',
		resources.reportCount.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get report data
export function getSalesReport(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		resources.salesReport.path,
		'',
		resources.salesReport.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get product purchase report data
export function exportProductPurchaseReport(payload, params, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		exports.productPurchaseReport.path,
		'',
		exports.productPurchaseReport.method,
		payload,
		params,
		true,
		null,
		callback
	);
}

// get account details
export function getAccountDetails(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		showLoader?true:false,
		null,
		callback
	);
}

// get delivery phone
export function getDeliveryPhone(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		null,
		callback,
		false
	);
}

export function getCustomerShipToDetails(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		showLoader,
		null,
		callback,
		false
	);
}

// get getSalesRepId
export function getSalesRepId(payload, callback, redirectToError = true) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		null,
		callback,
		redirectToError
	);
}

// get getSSOFromSalesRepId
export function getSSOFromSalesRepId(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get Address List
export function getAddressList(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		showLoader?true:false,
		null,
		callback
	);
}

// get relation ship party list attributes List
export function getRelationShipPartyList(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		showLoader?true:false,
		null,
		callback
	);
}

// get all Tca List
export function getAllTcaList(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		tca.getAllTca.path,
		'',
		tca.getAllTca.method,
		payload,
		'',
		showLoader?true:false,
		saveAllTcaList,
		callback
	);
}

export function getAllAdjPrcMod(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		ajdprcmod.getAllAdjPrcMod.path,
		'',
		ajdprcmod.getAllAdjPrcMod.path.method,
		payload,
		'',
		showLoader?true:false,
		saveAllAdjPrcModifier,
		callback
	);
}
export function storeReturnUda(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		tca.storeReturnUda.path,
		'',
		tca.storeReturnUda.method,
		payload,
		'',
		showLoader?true:false,
		null,
		callback
	);
}

export function storeCreditUda(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		tca.storeCreditUda.path,
		'',
		tca.storeCreditUda.method,
		payload,
		'',
		showLoader?true:false,
		null,
		callback
	);
}

// get address attributes List
export function getAddressAttributes(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		showLoader?true:false,
		null,
		callback
	);
}

// get sales agreement number for market area and region for NCRP
export function getNCRPSalesAgreementForMarketAreaAndRegion(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		pNetAPIUrl,
		users.ncrpSalesAgreement.path,
		'',
		users.ncrpSalesAgreement.method,
		payload,
		'',
		showLoader?true:false,
		null,
		callback
	);
}

// Get print request order details s3 path
export function printRequestOrderDetails(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		orders.printViewRequestDetails.path,
		'',
		orders.printViewRequestDetails.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Get print request order details s3 path
export function printProofOfDelivery(payload, queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		orders.printProofOfDelivery.path,
		'',
		orders.printProofOfDelivery.method,
		payload,
		queryStringParams,
		true,
		null,
		callback
	);
}

// get proof of delivery signature details
export function getSignatureDetails(payload, callback) {
	return generalActionToMakeServiceCall(
		orderAPIUrl,
		orders.getSignature.path,
		'',
		orders.getSignature.method,
		payload,
		'',
		true,
		saveSignatureDetails,
		callback
	);
}
// get proof of delivery signature details
export function getPOD(queryString, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.getPOD.path,
		'',
		orders.getPOD.method,
		queryString,
		null,
		true,
		null,
		callback,
		false
	);
}
// Create price tag
export function createPriceTags(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		priceTags.create.path,
		'',
		priceTags.create.method,
		payload,
		'',
		true,
		null,
		callback
	);
}
// get quote models by sales agreement
export function getModelsBySalesAgreement(payload, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		product.getQuoteModel.path,
		'',
		product.getQuoteModel.method,
		payload,
		'',
		true,
		saveBrochuresDetails,
		callback
	);
}
// get proof of delivery signature details
export function getSavedBrochures(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		brochure.savedBrochures.path,
		'',
		brochure.savedBrochures.method,
		payload,
		'',
		true,
		saveBrochuresDetails,
		callback
	);
}

/*new brochure change*/

export function getBrochureTemplateOptions() {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		brochure.brochureTemplateOption.path,
		'',
		brochure.brochureTemplateOption.method,
		null,
		'',
		true,
		updateBrochureTemplateOption,
		null
	);
}
/*end brochure change*/

// Create/edit Brochure
export function createNewBrochure(payload, hybridQueryParams, useBootAPI, method, callback) {
    return generalActionToMakeServiceCall(
        useBootAPI ? bootAPIUrl : reportsAPIUrl,
        brochure.createBrochure.path,
        '',
        method,
        payload,
        hybridQueryParams,
        true,
        null,
        callback
    );
}

// Create Binder
export function createNewBinder(payload, hybridQueryParams, useBootAPI, callback) {
    return generalActionToMakeServiceCall(
        useBootAPI ? bootAPIUrl : reportsAPIUrl,
        brochure.createBrochure.path,
        '',
        brochure.createBrochure.method,
        payload,
        hybridQueryParams,
        true,
        null,
        callback
    );
}

// delete brochure or binder
export function removeBrochureBinder(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		brochure.deleteBrochure.path,
		'',
		brochure.deleteBrochure.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Get search keyword
export function getSearchKeywordSuggestionList(payload, callback, showLoader = false) {
    return generalActionToMakeServiceCall(
        productAPIUrl,
        product.getKeyWordSuggession.path,
        '',
        product.getKeyWordSuggession.method,
        payload,
        '',
        showLoader,
        null,
        callback
    );
}

export function getQuoteModels(payload, callback) {
    return generalActionToMakeServiceCall(
        productAPIUrl,
        product.getKeyWordSuggession.path,
        '',
        product.getKeyWordSuggession.method,
        payload,
        '',
        true,
        null,
        callback
    );
}

// send product specs email
export function dropProductSpecsEmail(payload, hybridQueryParams, callback){
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		brochure.sendEmail.path,
		'',
		brochure.sendEmail.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// Below action only get list of all created price templates
export function getSavedExports(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.getSavedExports.path,
		'',
		exports.getSavedExports.method,
		payload,
		'',
		true,
		savePriceTemplates,
		callback
	);
}

// Below method is for create new price template
export function createPriceTemplate(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.createPriceTemplate.path,
		'',
		exports.createPriceTemplate.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Below method is for update price template
export function updatePriceTemplate(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.updatePriceTemplate.path,
		'',
		exports.updatePriceTemplate.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Below action delete template
export function deletePriceTemplate(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.deletePriceTemplate.path,
		'',
		exports.deletePriceTemplate.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// run export service
export function runExport(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.runExport.path,
		'',
		exports.runExport.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get product specs details for sku
export function getProductSpecs(payload, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		product.getProductSpecs.path,
		'',
		product.getProductSpecs.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// check for availability for skus
export function checkAvailabilityGeneric(payload, hybridQueryParams, whereToSave, showLoader, callback, redirectError = true) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkAvailability.path,
		'',
		product.checkAvailability.method,
		payload,
		hybridQueryParams,
		showLoader ? true : false,
		null,
		callback,
		redirectError
	);
}
// check for item orderability for skus
export function checkItemOrderability(queryString, showLoader, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.itemOrderability.path,
		'',
		orders.itemOrderability.method,
		queryString,
		null,
		showLoader ? true : false,
		null,
		callback,
		false
	);
}
// get prices for sku list
export function checkPricesForSearchResult(payload, showLoader, saveToStore, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkPrices.path,
		'',
		product.checkPrices.method,
		payload,
		'',
		showLoader?true:false,
		saveToStore?saveProductResultPrices:null,
		callback
	);
}

export function checkForPrices(payload, showLoader, saveToStore, cartOrOrder, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkPrices.path,
		'',
		product.checkPrices.method,
		payload,
		'',
		showLoader?true:false,
		saveToStore?(cartOrOrder === 'cart' ? savePricesToCart : savePricesToOrder):null,
		callback
	);
}

export function checkServicesPricesForCartPage(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkPrices.path,
		'',
		product.checkPrices.method,
		payload,
		hybridQueryParams,
		true,
		saveServicesPricesToCart,
		callback
	);
}

export function checkServicePrices(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkPrices.path,
		'',
		product.checkPrices.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

export function getPricesforAccessories(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkPrices.path,
		'',
		product.checkPrices.method,
		payload,
		'',
		true,
		'',
		callback
	);
}

export function getPriceOrder(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		product.priceOrder.path,
		'',
		product.priceOrder.method,
		payload,
		hybridQueryParams,
		true,
		'',
		callback,
		false
	);
}

export function getPIMItemInfo(payload, hybridQueryParams, callback, showLoader = true) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		product.pinItemInfo.path,
		'',
		product.pinItemInfo.method,
		payload,
		hybridQueryParams,
		showLoader,
		'',
		callback
	);
}

// get print specs pdf
export function printSpecsPDF(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		product.printSpecsPDF.path,
		'',
		product.printSpecsPDF.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get product line filters according to selected id and parameters if any
export function getProductLineFilters(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		product.getProductLineFilters.path,
		'',
		product.getProductLineFilters.method,
		payload,
		hybridQueryParams,
		true,
		saveProductLineFilters,
		callback
	);
}

// get product line narrow your result filters
/*waitToSaveToStore : In case of post login, if user clicks on any item in products/availability, narrow your result is parallel call and because of it it always clear dropdown of existing search result, hence passing flag if we want to wait until result comes or not*/
export function getProductLineNarrorYourResultFilters(payload, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		product.getNarrowProductLineFilters.path,
		'',
		product.getNarrowProductLineFilters.method,
		payload,
		'',
		null,
		saveProductLineNarrowYourResultsFilters,
		callback
	);
}

// get email to download excel sheet
export function exportProducts(payload, queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		nodeAPIurl,
		product.export.path,
		'',
		product.export.method,
		payload,
		queryStringParams,
		true,
		null,
		callback
	);
}

// get adc by passing zip code
export function getADC(queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		nodeAPIurl,
		product.adc.path,
		'',
		product.adc.method,
		queryStringParams,
		'',
		true,
		null,
		callback
	);
}

// get product comparison
export function getProductComparison(payload, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		product.getProductSpecs.path,
		'',
		product.getProductSpecs.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get account details
export function validateAccountNumber(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		false,
		null,
		callback
	);
}

// get product number keyword result and then reset and save new result
export function getProductNumberKeywordResult(searchStr, filters, params, typeOfSearch, callback, whichSearch, isPricingAccess, isPriceDiscountAccess) {
	return (dispatch) => {
		dispatch(resetProductNumberKeywordResultList());
		dispatch(saveNumberOfRecords(null));
		dispatch(resetResultLoaded());
		const promises = [];
		if (typeOfSearch !== 'quote-models') {
			searchStr = searchStr.trim();
			searchStr = searchStr.split(" ");
		}
		for(var i = 0; i < searchStr.length; i++) {
			promises.push(fetchProductNumberKeywordResult(searchStr[i].trim(), filters, params, typeOfSearch, 0, whichSearch, isPricingAccess, isPriceDiscountAccess));
		}
		dispatch(ajaxRequestInitiated());
		Promise.all(promises).then((responses) => {
			// logic to combine all responses and then run call back
			let responseObject = [];
			if(responses.length > 0) {
				responses.forEach(resp => {
					if (resp && resp.length) {
						responseObject = responseObject.concat(resp);
					}
				});
			}
			dispatch(saveProductNumberKeywordResultList({responseObject}));
			dispatch(ajaxRequestCompleted());
			callback(responseObject);
		});
    };
}

// get address verification data
export function getAddressVerificationData(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		prelogin.addressVerification.path,
		'',
		prelogin.addressVerification.method,
		payload,
		'',
		true,
		saveAddressVerificationData,
		callback
	);
}

// Save GE CustomerNet Registration data
export function createGECustomerNetRegistration(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		prelogin.geCustomerNetRegistration.path,
		'',
		prelogin.geCustomerNetRegistration.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get and save monogram data
export function getMonogramData(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.getMonogramData.path,
		'',
		exports.getMonogramData.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get and save performance data
export function getPerformanceData(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.getPerformanceData.path,
		'',
		exports.getPerformanceData.method,
		payload,
		'',
		true,
		null,
		callback
	);
}
export function getPrestigeData(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.getPrestigeData.path,
		'',
		exports.getPrestigeData.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

export function getGeDistributorData(payload, callback) {
	return generalActionToMakeServiceCall(
		reportsAPIUrl,
		exports.getGeDistributorData.path,
		'',
		exports.getGeDistributorData.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// update invalid login attempts
export function updateInvalidAttempt(payload, callback) {
	return generalActionToMakeServiceCall(
		loginAPIUrl,
		users.login.path,
		'',
		users.login.method,
		payload,
		'',
		true,
		saveInvalidAttempt,
		callback
	);
}

// get User Details details
export function checkCredentials(payload, callback) {
	return generalActionToMakeServiceCall(
		loginAPIUrl,
		users.login.path,
		payload.retry ? westLoginAPIKey : loginAPIKey,
		users.login.method,
		payload,
		'',
		true,
		null,
		callback,
		false
	);
}

// get assets
export function getAssets(showLoader, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		homepage.asset.path,
		'',
		homepage.asset.method,
		'',
		'',
		showLoader?true:false,
		saveAssets,
		callback
	);
}

export function getMessages(queryString, showLoader, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		homepage.message.path,
		'',
		homepage.message.method,
		queryString,
		'',
		showLoader?true:false,
		saveMessages,
		callback
	);
}

export function getRebatesAndClaims(queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		homepage.asset.path,
		'',
		homepage.asset.method,
		queryStringParams,
		'',
		true,
		saveRebatesAndClaims,
		callback
	);
}

export function createAsset(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		homepage.createAsset.path,
		'',
		homepage.createAsset.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}
export function createMessage(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		homepage.createMessage.path,
		'',
		homepage.createMessage.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

export function editAsset(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		homepage.editAsset.path,
		'',
		homepage.editAsset.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}
export function editMessage(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		homepage.editMessage.path,
		'',
		homepage.editMessage.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

export function createTokenAccount(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.createTokenAccount.path,
		'',
		users.createTokenAccount.method,
		payload,
		'',
		true,
		null,
		callback,
		false
	);
}

export function deleteAsset(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		homepage.deleteAsset.path,
		'',
		homepage.deleteAsset.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

export function deleteMessage(payload, hybridQueryParams, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		homepage.deleteMessage.path,
		'',
		homepage.deleteMessage.method,
		payload,
		hybridQueryParams,
		true,
		null,
		callback
	);
}

// Make this call to get registration help document
export function getRegistrationHelpDoc(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		resources.registrationHelp.path,
		'',
		resources.registrationHelp.method,
		payload,
		'',
		true,
		saveRegistrationHelpDoc,
		callback
	);
}

// Make this call to get documents details
export function getDocuments(payload, willSaveToStore, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		resources.mapGuideLines.path,
		'',
		resources.mapGuideLines.method,
		payload,
		'',
		true,
		willSaveToStore?saveDocuments:null,
		callback
	);
}

export const getPOKItems = (queryString, showLoader, callback) => generalActionToMakeServiceCall(
		pNetAPIUrl,
		product.getPOKItems.path,
		'',
		product.getPOKItems.method,
		`${queryString}&${PNET_APP_QUERY_PARAM}`,
		'',
		showLoader ? true : false,
		null,
		callback
	);

export const processPartsOrder = (payload, hybridQueryParams, showLoader, callback) => generalActionToMakeServiceCall(
		pNetAPIUrl,
		orders.processPartsOrder.path,
		'',
		orders.processPartsOrder.method,
		payload,
		hybridQueryParams,
		showLoader,
		null,
		callback
	);

export const checkPricesForPartsSearchResult = (payload, showLoader, saveToStore, callback) => generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkPrices.path,
		'',
		product.checkPrices.method,
		payload,
		PNET_APP_QUERY_PARAM,
		showLoader ? true : false,
		saveToStore ? data => saveProductResultPrices(data, true) : null,
		callback
	);

export const checkForPartsPrices = (payload, showLoader, saveToStore, cartOrOrder, callback) => generalActionToMakeServiceCall(
		bootAPIUrl,
		product.checkPrices.path,
		'',
		product.checkPrices.method,
		payload,
		PNET_APP_QUERY_PARAM,
		showLoader ? true : false,
		saveToStore ? (cartOrOrder === 'cart' ? data => savePricesToCart(data, true) : data => savePricesToOrder(data, true)) : null,
		callback
	);

// Make this call to get the URL of a file in S3 bucket
export const getFileURL = (path, queryString, callback) => generalActionToMakeServiceCall(
		pNetAPIUrl,
		path,
		'',
		'GET',
		queryString,
		'',
		true,
		null,
		callback
	);

// Make this call to get parts online pricing
export const getOnlinePricingForParts = (payload, hybridQueryParams, callback) => generalActionToMakeServiceCall(
		pNetAPIUrl,
		product.priceOrder.path,
		'',
		product.priceOrder.method,
		payload,
		hybridQueryParams,
		true,
		'',
		callback,
		false
	);

// add to parts cart
export const addToPartsCart = (payload, callback) => generalActionToMakeServiceCall(
		servicesAPIUrl,
		cart.put.path,
		'',
		cart.put.method,
		payload,
		PNET_APP_QUERY_PARAM,
		true,
		saveToCart,
		callback
	);

// Make this call to get non GEA SSO user details
export const getNonGEASSOUserAccounts = (payload, callback) => generalActionToMakeServiceCall(
		pNetAPIUrl,
		users.nonGEASSOUserAccounts.path,
		'',
		users.nonGEASSOUserAccounts.method,
		payload,
		'',
		true,
		null,
		callback,
		false
	);

// Make this call to update non GEA SSO user details
export const updateNonGEASSOUser = (payload, hybridQueryParams, callback) => generalActionToMakeServiceCall(
		pNetAPIUrl,
		users.nonGEASSOUserAccounts.path,
		'',
		'POST',
		payload,
		hybridQueryParams,
		true,
		null,
		callback,
		false
	);

// Make this call to delete non GEA SSO user details
export const deleteNonGEASSOUser = (payload, hybridQueryParams, callback) => generalActionToMakeServiceCall(
	pNetAPIUrl,
	users.nonGEASSOUserAccounts.path,
	'',
	'DELETE',
	payload,
	hybridQueryParams,
	true,
	null,
	callback,
	false
);

// A Generic API for site management (eg: uploading files to s3)
export const siteManagement = (payload, hybridQueryParams, showLoader, callback) => generalActionToMakeServiceCall(
		customerAPIUrl,
		resources.siteManagement.path,
		'',
		resources.siteManagement.method,
		payload,
		hybridQueryParams,
		showLoader,
		null,
		callback,
		false
	);

// Make this call to get invoice pdf link
export function getInvoicePDF(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.invoice.path,
		'',
		orders.invoice.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Make this call to get invoices
export function getInvoices(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		orders.invoice.path,
		'',
		orders.invoice.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Make this call to get user profile details
export function getUserDetails(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.details.path,
		'',
		users.details.method,
		payload,
		'',
		true,
		saveUserOtherDetails,
		callback
	);
}

// Make this call to get role list
export function getRoleList(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		saveRoleList,
		callback
	);
}

// Make this call to get contact list
// export function getContactList(payload, callback) {
// 	return generalActionToMakeServiceCall(
// 		customerAPIUrl,
// 		users.account.path,
// 		'',
// 		users.account.method,
// 		payload,
// 		'',
// 		true,
// 		null,
// 		callback
// 	);
// }

// Make this call to delete role
export function deleteUser(payload, queryStringParams, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.delete.path,
		'',
		users.delete.method,
		payload,
		queryStringParams,
		true,
		null,
		callback
	);
}

// Make this call to get user profile details
export function getOthersUserDetails(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.details.path,
		'',
		users.details.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Make this call to get users of account
export function getUsersOfAccount(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.details.path,
		'',
		users.details.method,
		payload,
		'',
		showLoader?true:false,
		saveUsersOfAccount,
		callback
	);
}

// Make this call to check if user is ASM for other account
export function checkOtherAccountASM(queryString) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.asm.path,
		'',
		users.asm.method,
		queryString,
		'',
		true,
		updateUserASMOfOtherAccount,
		null
	);
}
export function getEncryptedACB(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		resources.mapGuideLines.path,
		'',
		resources.mapGuideLines.method,
		payload,
		'',
		true,
		saveEncryptedAcb,
		callback
	);
}

// get local user details
export function getLocalUserDetails(payload, showLoader, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.details.path,
		'',
		users.details.method,
		payload,
		'',
		showLoader?true:false,
		saveLocalUserDetails,
		callback
	);
}

// get others local user details
export function getOthersLocalUserDetails(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.details.path,
		'',
		users.details.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Make this call to get approved accounts
export function getApprovedAccounts(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Make this call to get approved accounts
export function getAccountList(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Make this call to get other users approved accounts
export function getOthersApprovedAccounts(payload, callback) {
	return generalActionToMakeServiceCall(
		customerAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// Make this prices sources of selected account
export function getSelectedAccountsPriceSource(queryString, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		queryString,
		'',
		true,
		null,
		callback
	);
}

// get contact details of selected address
export function getOrgContactPointList(payload, callback) {
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.account.path,
		'',
		users.account.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get user contact point list
export function getUserContactPointList(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.details.path,
		'',
		users.details.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get admin email address
export function getAdminEmailAddress(payload, callback) {
	return generalActionToMakeServiceCall(
		userAPIUrl,
		users.adminDetails.path,
		'',
		users.adminDetails.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get list details
export function getList(queryStringParams, showLoader, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		list.get.path,
		'',
		list.get.method,
		queryStringParams,
		'',
		showLoader?true:false,
		saveToList,
		callback
	);
}

// add to list
export function addToList(payload, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		list.put.path,
		'',
		list.put.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

export function getProductsFromS3(payload, callback) {
	return generalActionToMakeServiceCall(
		productAPIUrl,
		cart.getProductsFromS3.path,
		'',
		cart.getProductsFromS3.method,
		payload,
		'',
		true,
		null,
		callback
	);
}

// get cart details
export function getCart(queryStringParams, showLoader, callback) {
	return generalActionToMakeServiceCall(
		servicesAPIUrl,
		cart.get.path,
		'',
		cart.get.method,
		queryStringParams,
		'',
		showLoader?true:false,
		saveToCart,
		callback
	);
}

// add to cart
export function addToCart(payload, callback) {
	const isPunchOutAccess = (localStorage.getItem("punchOutAccess") == true || localStorage.getItem("punchOutAccess") == 'true')
	if(isPunchOutAccess){
		if(payload.cartItems && payload.cartItems.length > 0){
			payload.cartItems = payload.cartItems.map(item => ({
					...item,
					agreementNumber : item.agreementNumber.toString(),
					quantity : parseInt(item.quantity),
					packageName: null,
					orderNumber: null,
					orderLineId: null,
					orderDate: null,
					poNumber: null,
					keepOriginalPrice: null,
					keepOriginalPO: null,
					buyerLineNo: null,
					overpackQuantityRequired: null,
					packageQuantity: null
				}
			))
		}
		let response = {responseObject :{
				...payload,
			},
			status : true,
			responseCode:200,
			responseMessage: null
		};
		return (dispatch) => {
				dispatch(saveToCart(response));
				callback && callback(response);
		}
	}
	else{
		return generalActionToMakeServiceCall(
			servicesAPIUrl,
			cart.put.path,
			'',
			cart.put.method,
			payload,
			'',
			true,
			saveToCart,
			callback
		);
	}
}

export function postPunchOutData(payload, postUrl, callback){
	return generalActionToMakeServiceCall(
		postUrl,
		'',
		'',
		'POST',
		payload,
		'',
		true,
		null,
		callback
	);
}

export function getPunchOutData(queryStringParams,callback){
	return generalActionToMakeServiceCall(
		bootAPIUrl,
		users.punchout.path,
		'',
		users.punchout.method,
		queryStringParams,
		"",
		true,
		null,
		callback
	);
}

/***************************************************************
	REDUCERS UPDATES CODE GOES BELOW
***************************************************************/
/***************************************************************
	Reducer Name: loading
***************************************************************/
export function ajaxRequestInitiated() {
    return { type: 'AJAX_REQUEST_INITIATED' }
}
export function ajaxRequestCompleted() {
    return { type: 'AJAX_REQUEST_COMPLETED' }
}
/***************************************************************/

/***************************************************************
	Reducer Name: order
***************************************************************/
export function saveIsOrderCreatedWithNewAddress(data) {
	return { type: 'IS_ORDER_CREATED_WITH_NEW_ADDRESS', data }
}
export function saveQuickOrderData(data) {
	return { type: 'SAVE_QUICK_ORDER_DATA', data }
}
export function isOrderPlaced(data) {
	return { type: 'IS_ORDER_PLACED', data }
}
export function resetOrderObjectInStoreException() {
	return { type: 'RESET_ORDER_OBJECT_EXCEPTION' }
}
export function setAvailabilityError(data) {
	return { type: 'SET_AVAILABILITY_ERROR', data }
}
export function saveAvailabilityOnChangeAddress(data) {
	return { type: 'SAVE_AVAIL_ON_CHANGE_ADDRESS', data }
}
export function saveAvailabilityPricingOfImportedFile(data) {
	return { type: 'SAVE_AVAIL_PRICING_OF_IMPORTED_FILE', data }
}
export function saveAccountResponsibility(data) {
	return { type: 'SAVE_ACCOUNT_RESPONSIBILITY_DATA', data }
}
export function saveCreateOrderPayloadBackup(data) {
	return { type: 'SAVE_CREATE_ORDER_PAYLOAD_BACKUP', data }
}
export function clearDeliveryMethodFromBackup() {
	return { type: 'CLEAR_DELIVERY_METHOD_FROM_BACKUP' }
}
export function saveApproveReturnsList(data) {
	return { type: 'SAVE_APPROVE_RETURNS_LIST', data }
}
export function saveShippingMethod(data) {
	return { type: 'SAVE_SHIPPING_METHOD', data }
}
export function saveUpdateBookedOrderConfirmationPageData(data) {
	return { type: 'SAVE_UPDATE_BOOKED_ORDER_CONFIRMATION_PAGE_DATA', data }
}
export function saveLookSerialNoData(data) {
	return { type: 'SAVE_LOOK_SERIAL_NO_DATA', data }
}
// reset prices to order
export function resetPricesToOrder() {
	return { type: 'RESET_PRICES_TO_ORDER' }
}
// save prices to order
export function savePricesToOrder(data, isPart = false) {
	return { type: 'SAVE_PRICES_TO_ORDER', data: isPart ? data : processPricingResponse(data) }
}
// update request return form parameters
export function updateRequestReturnParams(data) {
    return { type: 'UPDATE_REQUEST_RETURN_PARAMS', data }
}
// update request credit form parameters
export function updateRequestCreditParams(data) {
    return { type: 'UPDATE_REQUEST_CREDIT_PARAMS', data }
}
// save previous return and credit details
export function savePreviousReturnAndCreditDetails(data) {
    return { type: 'SAVE_PREVIOUS_RETURN_AND_CREDIT_DETAILS', data }
}
// save billing references
export function saveBillingReferences(data) {
    return { type: 'SAVE_BILLING_REFERENCES', data }
}
// save deleted items for edit order
export function saveDeletedItems(data) {
    return { type: 'SAVE_DELETED_ITEMS', data }
}
// Save minimum delivery amount
export function saveMinimumDeliveryAmount(data) {
    return { type: 'SAVE_MINIMUM_DELIVERY_AMOUNT', data }
}
// set org attributes
export function saveOrgAttributes(data) {
    return { type: 'SAVE_ORG_ATTRIBUTES', data }
}
// set orderable services
export function saveBookedOrders(data) {
    return { type: 'SAVE_BOOKED_ORDERS', data }
}
// set orderable services
export function saveOrderableServices(data) {
    return { type: 'SAVE_ORDERABLE_SERVICES', data }
}
// set request return details
export function saveCreateOrderPayload(data) {
    return { type: 'SAVE_CREATE_ORDER_PAYLOAD', data }
}
export function saveCreateWorkOrderPayload(data) {
	return { type: 'SAVE_CREATE_WORK_ORDER_PAYLOAD', data}
}
// set request return details
export function setRequestReturnDetails(data) {
    return { type: 'SAVE_REQUEST_RETURN_DETAILS', data }
}
// set request credit details
export function setRequestCreditDetails(data) {
    return { type: 'SAVE_REQUEST_CREDIT_DETAILS', data }
}
export function saveIsBackOrdersAvailable(data) {
    return { type: 'SAVE_IS_BACKORDERS_AVAILABLE', data }
}
export function saveIsBulkOrdersHoldAvailable(data) {
    return { type: 'SAVE_IS_BULK_ORDER_HOLD_AVAILABLE', data }
}
// Deleted order details updates to store
export function saveDeletedOrderProductsDetails(data) {
    return { type: 'SAVE_DELETED_ORDER_DETAILS', data }
}
// save account number into store (same for PreLogin and PostLogin)
export function saveAccountDetail(data) {
    return { type: 'SAVE_ACCOUNT_DETAIL', data }
}
export function saveRelationShipPartyList(data) {
    return { type: 'SAVE_RELATION_SHIP_PARTY_LIST', data }
}
export function saveAllTcaList(data) {
    return { type: 'SAVE_ALL_TCA_LIST', data }
}
export function saveAllAdjPrcModifier(data) {
	return { type: 'SAVE_ALL_ADJ_PRC_MOD', data }
}
export function saveAddressAttributes(data) {
    return { type: 'SAVE_ADDRESS_ATTRIBUTES', data }
}
export function resetLoadIndicatorBySiteNumber() {
    return { type: 'RESET_LOAD_INDICATOR_SITE_NUMBER' }
}
export function saveLoadIndicatorBySiteNumber(data) {
    return { type: 'SAVE_LOAD_INDICATOR_SITE_NUMBER', data }
}
export function updateLoadIndicatorBySiteNumber(data) {
    return { type: 'UPDATE_LOAD_INDICATOR_SITE_NUMBER', data }
}
// save signature details into store
export function saveSignatureDetails(data) {
    return { type: 'SAVE_SIGNATURE_DETAILS', data }
}
// Save manage order list state backtup to store
export function saveManageOrdersListBackup(data) {
    return { type: 'SAVE_MANAGE_ORDER_LIST_STATE_BACKUP', data }
}
// Save return products list to store
export function saveRequestReturnList(data) {
    return { type: 'SAVE_REQUEST_RETURN_LIST', data }
}
export function saveSerialData(data) {
    return { type: 'SAVE_SERIAL_DATA', data }
}
// Save return credit list to store
export function saveRequestCreditList(data) {
    return { type: 'SAVE_REQUEST_CREDIT_LIST', data }
}
export function saveSerialCreditData(data) {
    return { type: 'SAVE_SERIAL_CREDIT_DATA', data }
}
//Save return credit Pim data 
export function saveRequestCreditPimData(data) {
    return { type: 'SAVE_REQUEST_CREDIT_PIMDATA', data }
}
// Save request return Pim data
export function saveRequestReturnPimData(data) {
    return { type: 'SAVE_REQUEST_RETURN_PIMDATA', data }
}
// Save view requests list to store
export function saveViewRequestsListBackup(data) {
    return { type: 'SAVE_VIEW_REQUEST_LIST_BACKUP', data }
}
export function saveMobileView(data) {
    return { type: 'SAVE_MOBILE_VIEW', data }
}
// save order details list
export function saveOrderDetailsList(data) {
    return { type: 'SAVE_ORDER_DETAILS_LIST', data }
}
// save back order
export function saveBackOrders(data) {
    return { type: 'SAVE_BACK_ORDERS', data }
}
// save bulk order hold
export function saveBulkOrdersHold(data) {
    return { type: 'SAVE_BULK_ORDERS_HOLD', data }
}
// Save order details to store
export function saveOrderDetails(data) {
    return { type: 'SAVE_ORDER_DETAILS', data }
}

export function saveOriginalOrderDetails(data){
	return { type: 'SAVE_ORIGINAL_ORDER_DETAILS', data }
}

export function saveOrderShippingDetails(data) {
    return { type: 'SAVE_ORDER_SHIPPING_DETAILS', data }
}
export function saveTrackingDetails(data) {
    return { type: 'SAVE_TRACKING_DETAILS', data }
}
/***************************************************************/

/***************************************************************
	Reducer Name: package
***************************************************************/
// savePackageList
export function savePackageList(data) {
    return { type: 'SAVE_PACKAGE_LIST', data }
}
export function saveCreatedPackageDetails(data) {
	return { type: 'SAVE_CREATED_PACKAGE_DETAILS', data }
}
/***************************************************************/

/***************************************************************
	Reducer Name: Exports
***************************************************************/
// Below action save templates to store
export function savePriceTemplates(data) {
	return { type: 'SAVE_PRICE_TEMPLATES', data }
}

export function saveTemplateId(data) {
	return { type: 'SAVE_TEMPLATE_ID', data }
}
// Set edit template payload
export function setEditTemplatePayload(data) {
 	return { type: 'SET_EDIT_TEMPLATE_PAYLOAD', data }
}

/***************************************************************/

/***************************************************************
	Reducer Name: Price Tags
***************************************************************/
// save selected sku for create price tags
export function savePriceTagsSku(data) {
    return { type: 'SAVE_SELECTED_ITEMS_FOR_PRICE_TAGS', data }
}

/***************************************************************/

/***************************************************************
	Reducer Name: Brochures
***************************************************************/
// save brochure details to store
export function saveBrochuresDetails(data) {
    return { type: 'SAVE_BROCHURE_DETAILS', data }
}
// Add new page in first step
export function addNewPage() {
	return { type: 'ADD_NEW_PAGE' }
}
// Update pages data
export function updatePages(data) {
	return { type: 'UPDATE_PAGES', data }
}
// Add extra product in assign dialog
export function addExtraProduct() {
	return { type: 'ADD_EXTRA_PRODUCT' }
}
// select brochure radio option
export function selectBrochureCreateOption(data) {
	return { type: 'SELECT_BROCHURE_CREATE_OPTION', data }
}

/*new brochure change*/
// select brochure radio option
export function selectFeatureCreateOption(data) {
	return { type: 'SELECT_FEATURE_CREATE_OPTION', data }
}

export function updateBrochureTemplateOption(data) {
	return { type: 'UPDATE_BROCHURE_TEMPLATE_OPTION', data }
}
/*end brochure change*/

// Update other added products
export function updateOtherAddedProducts(data) {
	return { type: 'UPDATE_OTHER_ADDED_PRODUCTS', data }
}
// Update selected items in brochure store
export function updateSelectedItems(data) {
	return { type: 'UPDATE_SELECTED_ITEMS', data }
}
// Update brochure parameters
export function updateBrochureParameter(data) {
	return { type: 'UPDATE_BROCHURE_PARAM', data }
}
// Update brochure customer info
export function updateBrochureProductInfo(data) {
	return { type: 'UPDATE_BROCHURE_PRODUCT_INFO', data }
}
// Update brochure product info
export function updateBrochureCustomerInfo(data) {
	return { type: 'UPDATE_BROCHURE_CUSTOMER_INFO', data }
}
// Update brochure for more info
export function updateBrochureForMoreInfo(data) {
	return { type: 'UPDATE_BROCHURE_FOR_MORE_INFO', data }
}
// Update brochure cover page info
export function updateBrochureCoverPageInfo(data) {
	return { type: 'UPDATE_BROCHURE_COVER_PAGE_INFO', data }
}
// Update brochure product color info
export function updateBrochureProductColorInfo(data) {
	return { type: 'UPDATE_BROCHURE_PRODUCT_COLOR_INFO', data }
}
// Load selected brochure in payload so that existing data will be loaded in steps
export function loadSelectedSavedBrochure(data) {
	return { type: 'LOAD_SELECTED_SAVED_BROCHURE', data }
}
// Reset brochure payload
export function resetBrochurePayload(data) {
    return { type: 'RESET_BROCHURE_PAYLOAD', data }
}
// send email from PDFViewer
export function sendEmailSuccessDialog(data) {
    return { type: 'EMAIL_SEND_SUCCESS_DIALOG', data };
}
// Create new binder payload
export function createNewBinderPayload() {
	return { type: 'CREATE_NEW_BINDER_PAYLOAD' }
}
// Update binder parameters
export function updateBinderParameter(data) {
   	return { type: 'UPDATE_BINDER_PARAM', data }
}
// Update print or cd shipping address param
export function updateBinderShippingAddressParam(data) {
	return { type: 'UPDATE_BINDER_SHIPPING_ADDRESS_PARAM', data }
}
/***************************************************************/

/***************************************************************
	Reducer Name: product
***************************************************************/
// Show loading icon near by account number
export function saveADC(data) {
	return { type: 'SAVE_ADC', data};
}
// Show loading icon near by account number
export function showAccountDetailProgress(data) {
	return { type: 'SHOW_ACCOUNT_DETAIL_PROGRESS', data};
}
// Show loading icon near by zip code
export function showZipCodeLoading(data) {
  	return { type: 'SHOW_ZIP_CODE_PROGRESS', data};
}
// This will be dispatched once we have all parallel call of product prices and availability are completed
export function updateAvailabilityWithPricesAndDiscounts() {
    return { type: 'UPDATE_AVAILABILITY_WITH_PRICES_AND_DISCOUNTS' }
}
export function updateAvailabilityForPreLogin() {
    return { type: 'UPDATE_AVAILABILITY_FOR_PRE_LOGIN' }
}
export function resetProductAvailabilityResultList() {
    return { type: 'RESET_PRODUCT_AVAILABILITY_RESULT_LIST' }
}
// Update fromWhere to identify from where prouct line is clicked. (Either user refresh page or clicked on header menu)
export function updateFromWhereProductLineClicked(data) {
	return { type: 'UPDATE_FROM_WHERE_PRODUCT_LINE_CLICKED', data }
}
export function resetProductPricesResultList() {
    return { type: 'RESET_PRODUCT_PRICE_RESULT_LIST' }
}
// Save product specs
export function saveProductSpecs(data) {
    return { type: 'SAVE_PRODUCT_SPECS', data }
}
// Save product result availability result in store
export function saveProductResultAvailability(data) {
    return { type: 'SAVE_PRODUCT_RESULT_AVAILABILITY', data }
}
// Save product result prices result in store
export function saveProductResultPrices(data, isPart = false) {
    return { type: 'SAVE_PRODUCT_RESULT_PRICES', data: isPart ? data : processPricingResponse(data) }
}
// Save Zip Code details to user object
export function saveZipCodeDetail(data) {
  	return { type: 'SAVE_ZIP_CODE_DETAILS', data };
}
// Save Zip Code to show in result page
export function saveZipCode(data) {
    return { type: 'SAVE_ZIP_CODE', data}
}
// Save account number to show in result page
export function saveAccountNumber(data) {
    return { type: 'SAVE_ACCOUNT_NUMBER', data}
}
// Save account number details to user object
export function saveAccountNumberDetails(data) {
	return { type: 'SAVE_ACCOUNT_DETAIL', data };
}
// Save selected product line from dropdown of pre login home page
export function saveProductLine(data) {
    return { type: 'SAVE_PRODUCT_LINE', data }
}
// Show hide auto select
export function showHideAutoSelect(data) {
    return { type: 'SHOW_HIDE_AUTO_SELECT', data}
}
// Reset list of product number result of keyword
export function resetProductNumberKeywordResultList() {
    return { type: 'RESET_PRODUCT_NUMBER_KEYWORD_RESULT_LIST' }
}
// Save product line filters
export function saveProductLineFilters(data) {
    return { type: 'SAVE_PRODUCT_LINE_FILTERS', data }
}
// Save product line narrow your result filters
export function saveProductLineNarrowYourResultsFilters(data) {
    return { type: 'SAVE_PRODUCT_LINE_NARROW_YOUR_RESULTS_FILTERS', data }
}
// Set number of records of search results
export function saveNumberOfRecords(data) {
    return { type: 'SAVE_NUMBER_OF_RECORDS', data }
}
export function resetResultLoaded() {
    return { type: 'RESET_RESULT_LOADED' }
}
// Save result of product number keyword selected in auto search
export function saveProductNumberKeywordResultList(data) {
    return { type: 'SAVE_PRODUCT_NUMBER_KEYWORD_RESULT_LIST', data }
}
// Update result of product number keyword selected in auto search
export function updateProductNumberKeywordResultList(data) {
    return { type: 'UPDATE_PRODUCT_NUMBER_KEYWORD_RESULT_LIST', data }
}
// Set number of service call will be made for checking availability
export function saveProductAvailabilityCallCompleted(data) {
    return { type: 'SAVE_PRODUCT_AVAILABILITy_CALL_COMPLETED', data }
}
// Set number of service call will be made for checking pricing
export function saveNumberOfParallelCallForProductPrices(data) {
    return { type: 'SAVE_NUMBER_OF_PARALLEL_CALL_FOR_PRODUCT_PRICES', data }
}
// Below action will set completed number of call with current value + 1
export function saveCompletedNumberOfParallelCallForProductPrices() {
    return { type: 'SAVE_COMPLETED_NUMBER_OF_PARALLEL_CALL_FOR_PRODUCT_PRICES' }
}
// Save narrow your result selected dropdown values
export function saveNarrowYourResultSelectedValue(data) {
    return { type: 'SAVE_NARROW_YOUR_RESULT_SELECTED_VALUE', data }
}
// Save parts search results in store
export function savePartsSearchResult(data) {
    return { type: 'SAVE_PARTS_SEARCH_RESULT', data };
}
// Clear parts search results in store
export function clearPartsSearchResult() {
    return { type: 'CLEAR_PARTS_SEARCH_RESULT' };
}
/***************************************************************/

/***************************************************************
	Reducer Name: searchKeyword
***************************************************************/
// Post Login : Save entered keyword in product number search
export function savePostLoginSearchKeyword(data) {
    return { type: 'SAVE_POST_LOGIN_SEARCH_KEYWORD', data }
}
// Post Login : Reset list of search keyword for auto select
export function resetSearchKeywordSuggestionList() {
    return { type: 'RESET_SEARCH_KEYWORD_SUGGESTION_LIST' }
}
// Post Login : Save list of search keyword for auto select
export function saveSearchKeywordSuggestionList(data) {
    return { type: 'SAVE_SEARCH_KEYWORD_SUGGESTION_LIST', data }
}
/***************************************************************/

/***************************************************************
	Reducer Name: user
***************************************************************/
export function updateSelectedAddress(data) {
    return { type: 'UPDATE_SELECTED_ADDRESS', data };
}
export function setDefaultADC(data) {
    return { type: 'SET_DEFAULT_ADC', data };
}
export function setSelectedADC(data) {
    return { type: 'SET_SELECTED_ADC', data };
}
// update invalid login attempts
export function saveInvalidAttempt(data) {
    return { type: 'SAVE_INVALID_LOGIN_ATTEMPTS', data };
}
export function saveGEAdBuilderKey(data) {
	return { type: 'SAVE_GE_AD_BUILDER_KEY', data };
}
export function saveEncryptedAcb(data) {
	return { type: 'SAVE_ENCRYPTED_ACB', data };
}
// update session status
export function saveShippingAddresses(data) {
    return { type: 'SAVE_SHIPPING_ADDRESSES', data };
}
export function updateShippingAddresses(data) {
    return { type: 'UPDATE_SHIPPING_ADDRESSES', data };
}
export function resetShippingAddresses() {
    return { type: 'RESET_SHIPPING_ADDRESSES',  };
}
// save address list into store
export function saveAddressList(data) {
    return { type: 'SAVE_ADDRESS_LIST', data }
}
// get customer ship to details into store
export function saveCustomerShipToDetails(data) {
    return { type: 'SAVE_CUSTOMER_SHIP_TO_DETAILS', data }
}
// save all addresses including address4: "JOB SITE"
export function saveAllJobSiteAddressList(data) {
    return { type: 'SAVE_ALL_JOB_SITE_ADDRESS_LIST', data }
}
// get customer ship to details for create and edit order into store
export function otherCustomerShipToDetailsForOrder(data) {
    return { type: 'SAVE_CUSTOMER_SHIP_TO_DETAILS_FOR_ORDER', data }
}
// save selected address backup
export function saveSelectedAddressBackup(data) {
    return { type: 'SAVE_SELECTED_ADDRESS_BACKUP', data }
}
// update session status
export function updateSessionStatus(data) {
    return { type: 'UPDATE_SESSION_STATUS', data };
}
// Save account and source from home page popup on landing on home page after login.
export function saveSelectedAccountsAllPriceSources(data) {
    return { type: 'SAVE_SELECTED_ACCOUNTS_ALL_PRICE_SOURCES', data };
}
// save all sales agreement without filtering
export function saveSelectedAccountsAllPriceSourcesWithoutFilter(data) {
    return { type: 'SAVE_SELECTED_ACCOUNTS_ALL_PRICE_SOURCES_WITHOUT_FILTER', data };
}
// Save account and source from home page popup on landing on home page after login.
export function saveSelectedAccountAndPriceSource(data) {
    return { type: 'SAVE_ACCOUNT_AND_PRICE_SOURCE', data };
}
// Save account number details to user object
export function saveAccountNumberPostLogin(data) {
	return { type: 'SAVE_ACCOUNT_DETAIL_POST_LOGIN', data };
}
// Validate and redirect to home page on successfull login
export function saveUserDetails(data) {
    return { type: 'SAVE_USER_DETAILS', data }
}
// save user other details
export function saveUserOtherDetails(data) {
    return { type: 'SAVE_USER_OTHER_DETAILS', data }
}
export function saveRoleList(data) {
    return { type: 'SAVE_ROLE_LIST', data }
}
// save users of account
export function saveUsersOfAccount(data) {
    return { type: 'SAVE_USERS_OF_ACCOUNT', data }
}
// save ASMs of selected account
export function saveSelectedAccountASMDetails(data) {
    return { type: 'SAVE_SELECTED_ACCOUNT_ASM_DETAILS', data }
}
// update user details whether user is asm or not
export function updateUserASMOrNot(data) {
    return { type: 'UPDATE_USER_ASM_OR_NOT', data }
}
export function updateUserASMOfOtherAccount(data) {
    return { type: 'UPDATE_USER_ASM_OF_OTHER_ACCOUNT', data }
}
// update user details whether user is in DL or not
export function updateUserIsInDLOrNot(data) {
    return { type: 'UPDATE_USER_IS_IN_DL_OR_NOT', data }
}
// save manage site access
export function saveManageSiteAccess(data) {
    return { type: 'SAVE_MANAGE_SITE_ACCESS', data }
}
// update user details whether user is admin or not
export function updateUserAdminOrNot(data) {
    return { type: 'UPDATE_USER_ADMIN_OR_NOT', data }
}
// Save user profile details
export function saveUserProfile(data) {
    return { type: 'SAVE_USER_PROFILE', data }
}
// reseting the user deatils in case of login failure
export function resetUserDetails() {
    return { type: 'RESET_USER_DETAILS' }
}
// Save account details
export function saveApprovedAccountDetails(data) {
    return { type: 'SAVE_APPROVED_ACCOUNT_DETAILS', data }
}
// backupNotificationList
export function backupNotificationList() {
    return { type: 'BACKUP_NOTIFICATION_LIST' }
}
// Save organization contact point list
export function saveOrgContactPointList(data) {
    return { type: 'SAVE_ORG_CONTACT_POINT_LIST', data }
}
// Save user contact point list
export function saveUserContactPointList(data) {
    return { type: 'SAVE_USER_CONTACT_POINT_LIST', data }
}
// update selected notification list
export function selectAllNotificationList(data) {
    return { type: 'SELECT_ALL_NOTIFICATION_LIST', data }
}
// Update specific notification
export function updateNotification(data) {
    return { type: 'UPDATE_NOTIFICATION', data }
}
// save User pending request in user profile object
export function saveUserPendingRequests(data) {
    return { type: 'SAVE_USER_PENDING_REQUESTS', data }
}
// save user local details
export function saveLocalUserDetails(data) {
    return { type: 'SAVE_LOCAL_USER_DETAILS', data }
}
// save generic NCRP Account Details
export function saveGenericNCRPAccount(data) {
    return { type: 'SAVE_GENERIC_NCRP_ACCOUNT', data }
}
/***************************************************************/

/***************************************************************
	Reducer Name: registration
***************************************************************/
// Save parameters of sso registration page which will be used in ge customernet registration page
export function saveSSORegistrationDetails(data) {
    return { type: 'SAVE_SSO_REGISTRATION', data }
}
// Show/hide address verification dialog
export function showAddressVerificationDialog(data) {
    return { type: 'SHOW_ADDRESS_VERIFICATION_DIALOG', data }
}
// Maintain addressException
export function addressExceptionDispatch(data) {
    return { type: 'ADDRESS_EXCEPTION_DISPATCH', data }
}
// save address verification data
export function saveAddressVerificationData(data) {
    return { type: 'SAVE_ADDRESS_VERIFICATION', data }
}
// Save status of valid account number or not
export function saveIsAnyValidAccountNumber(data) {
    return { type: 'SAVE_IS_ANY_VALID_ACCOUNT_NUMBER', data }
}
// Save status of account is already approved or reject
export function saveIsAlreadyApprovedOrPending(data) {
    return { type: 'SAVE_IS_ALREADY_APPROVED_OR_REJECT', data }
}
// Reset Account number of array of objects for initial load
export function resetGEAccountNumbers() {
    return { type: 'RESET_GE_CUSTNET_ACCOUNT_NUMBERS' }
}
// Save Account number of array of objects
export function saveGEAccountNumbers(data) {
	return { type: 'SAVE_GE_CUSTNET_ACCOUNT_NUMBERS', data }
}
// Disable update accounts button in My Profile page
export function disableUpdateButton(data) {
    return { type: 'ENABLE_DISABLE_BUTTON', data }
}
/***************************************************************/

/***************************************************************
	Reducer Name: resources
***************************************************************/
// save monogram data in store
export function saveMonogramData(data) {
    return { type: 'SAVE_MONOGRAM_DATA', data }
}
export function saveGeDistributorData(data) {
    return { type: 'SAVE_GE_DISTRIBUTOR_DATA', data }
}
// save price sheets data
export function savePriceSheets(data) {
    return { type: 'SAVE_PRICE_SHEETS', data }
}
// save sales handbook Agreement data
export function saveSalesAgreementHandBookData(data) {
    return { type: 'SAVE_SALES_AGREEMENT_HANDBOOK', data }
}
// save performance data in store
export function savePerformanceData(data) {
    return { type: 'SAVE_PERFORMANCE_DATA', data };
}
export function savePrestigeData(data) {
    return { type: 'SAVE_PRESTIGE_DATA', data };
}
// Save documents
export function saveDocuments(data) {
	return { type: 'SAVE_DOCUMENTS', data };
}
// save registration help doc details
export function saveRegistrationHelpDoc(data) {
	return { type: 'SAVE_REGISTRATION_HELP_DOCUMENTS', data };
}
// Save claim forms documents
export function saveClaimFormsDocuments(data) {
	return { type: 'SAVE_CLAIM_FORMS_DOCUMENTS', data };
}
// Save full catalog documents
export function saveFullCatalogDocuments(data) {
	return { type: 'SAVE_FULL_CATALOG_DOCUMENTS', data };
}
/***************************************************************/

/***************************************************************
	Reducer Name: errors
***************************************************************/
export function addErrorLogToStore(data) {
    return { type: 'ADD_ERROR_LOG', data };
}
export function resetErrorLog() {
    return { type: 'RESET_ERROR_LOG' };
}
/* Page specific error details */
export function addErrorDetailsToStore(data) {
    return { type: 'ADD_ERROR_DETAILS', data };
}
export function resetErrorDetails() {
    return { type: 'RESET_ERROR_DETAILS' };
}
/***************************************************************/

/***************************************************************
	Reducer Name: homepage
***************************************************************/
export function populateLatestHomePageAssets() {
    return { type: 'POPULATE_LATEST_HOMEPAGE_ASSETS' };
}
export function saveAssets(data) {
    return { type: 'SAVE_ASSETS', data };
}
export function saveMessages(data) {
    return { type: 'SAVE_MESSAGES', data };
}
export function saveRebatesAndClaims(data) {
	return { type: 'SAVE_REBATES_AND_CLAIMS', data };
}
export function saveAssetsFilters(data) {
    return { type: 'SAVE_ASSETS_FILTERS', data };
}
export function updateHomePageAssetsFromBackup(data) {
    return { type: 'UPDATE_HOME_PAGE_ASSETS', data };
}
export function saveEditAssets(data) {
    return { type: 'SAVE_EDIT_ASSET', data };
}
export function saveEditRebatesAssets(data) {
    return { type: 'SAVE_EDIT_REBATES_AND_CLAIMS', data };
}
export function saveEditPriceExports(data) {
    return { type: 'SAVE_EDIT_PRICE_EXPORTS', data };
}
// update rotating banners
export function updateRotatingBannersObject(data) {
    return { type: 'UPDATE_ROTATING_BANNERS', data };
}
/***************************************************************/

/***************************************************************
	All reducers: on click of logout reset all reducers in store
/***************************************************************/
export function resetErrorsObjectInStore() {
    return { type: 'RESET_ERRORS_REDUCERS' }
}
// Reset Brochure object in store
export function resetBrochureObjectInStore() {
    return { type: 'RESET_BROCHURE_REDUCERS' }
}
// Reset export object in store
export function resetExportObjectInStore() {
    return { type: 'RESET_EXPORTS_REDUCERS' }
}
// Reset Homepage object in store
export function resetHomePageObjectInStore() {
    return { type: 'RESET_HOMEPAGE_REDUCERS' }
}
// Reset Loading object in store
export function resetLoadingObjectInStore() {
    return { type: 'RESET_LOADING_REDUCERS' }
}
// Reset Order object in store
export function resetOrderObjectInStore() {
    return { type: 'RESET_ORDER_REDUCERS' }
}
// Reset Package object in store
export function resetPackageObjectInStore() {
    return { type: 'RESET_PACKAGE_REDUCERS' }
}
// Reset Price tags object in store
export function resetPriceTagsObjectInStore() {
    return { type: 'RESET_PRICE_TAGS_REDUCERS' }
}
// Reset Product object in store
export function resetProductObjectInStore() {
    return { type: 'RESET_PRODUCT_REDUCERS' }
}
// Reset Registration object in store
export function resetRegistrationObjectInStore() {
    return { type: 'RESET_REGISTRATION_REDUCERS' }
}
// Reset resources object in store
export function resetResourcesObjectInStore() {
    return { type: 'RESET_RESOURCES_REDUCERS' }
}
// Reset Search Keyword object in store
export function resetSearchKeywordObjectInStore() {
    return { type: 'RESET_SEARCH_KEYWORD_REDUCERS' }
}
// Reset User object in store
export function resetUserObjectInStore() {
    return { type: 'RESET_USER_REDUCERS' }
}
// Reset Cart object in store
export function resetCartObjectInStore() {
    return { type: 'RESET_CART_REDUCERS' }
}
// Reset List object in store
export function resetListObjectInStore() {
    return { type: 'RESET_LIST_REDUCERS' }
}
/***************************************************************/

/***************************************************************
	Reducer Name: list
***************************************************************/
// save to list
export function saveToList(data) {
    return { type: 'SAVE_TO_LIST', data }
}

// save availability to list
export function saveAvailabilityToList(data){
	return { type: 'SAVE_PRODUCT_AVAILABILITY_LIST', data}
}
export function resetAvailabilityToList() {
	return { type: 'RESET_AVAILABILITY_TO_LIST' }
}
export function savePimDataForList(data) {
	return { type: 'SAVE_PIM_DATA_FOR_LIST', data }
}

/***************************************************************/

/***************************************************************
	Reducer Name: cart
***************************************************************/
// export function setShowIFWarningMessage(data) {
// 	return { type: 'SHOW_IF_WARNING_MESSAGE', data }
// }
export function resetAvailabilityToCart() {
	return { type: 'RESET_AVAILABILITY_TO_CART' };
}
export function updateCartOrderPoints(data) {
	return { type: 'UPDATE_CART_ORDER_POINTS', data};
}
// save to cart
export function saveToCart(data) {
    return { type: 'SAVE_TO_CART', data }
}
export function saveBackupCartItem(data) {
    return { type: 'SAVE_TO_CART_BACKUP', data }
}
export function saveBackOrderCartItem(data) {
    return { type: 'SAVE_TO_CART_BACKORDERS', data }
}
// save availability to cart
export function saveAvailabilityToCart(data) {
	return { type: 'SAVE_PRODUCT_AVAILABILITY_CART', data }
}

// save prices to cart
export function savePricesToCart(data, isPart = false) {
	return { type: 'SAVE_PRICES_TO_CART', data: isPart ? data : processPricingResponse(data) }
}

export function saveServicesPricesToCart(data) {
	return { type: 'SAVE_SERVICES_PRICES_TO_CART', data }
}

export function resetServicesPricesToCart() {
	return { type: 'RESET_SERVICES_PRICES_TO_CART' }
}

export function updatePricesToCart(data) {
	return { type: 'UPDATE_PRICES_TO_CART', data }
}

export function resetPricesToCart() {
	return { type: 'RESET_PRICES_TO_CART' }
}

/***************************************************************/


// WEBPACK FOOTER //
// ./src/App/redux/actions/index.js